<div mat-dialog-content class="text-center">
  <h3>
    {{msg}}
  </h3>
</div>
<div mat-dialog-actions align="center">
  <button mat-flat-button color="primary" *ngIf="showYes" (click)="answerClick(1)"
    cdkFocusInitial>{{ yesText }}</button>
  <button mat-button [hidden]="this.noText=='' || this.noText==null" (click)="answerClick(0)">{{noText}}</button>
</div>